<kendo-chart [transitions]="false"  style="width: 300px; height: 300px;">
  <kendo-chart-legend
    position="bottom"
    orientation="horizontal"
  ></kendo-chart-legend>
  <kendo-chart-tooltip format="{0}Volt"></kendo-chart-tooltip>
  <kendo-chart-series>
    <kendo-chart-series-item
      type="line"
     [data]="data"
    >
    </kendo-chart-series-item>
  </kendo-chart-series>
</kendo-chart>

